import React from 'react';
import { usePlayer } from '../../lib/PlayerContext';
import { useNavigate } from 'react-router-dom';

interface AuthRequiredModalProps {
  title?: string;
  message?: string;
}

const AuthRequiredModal: React.FC<AuthRequiredModalProps> = ({
  title = 'Sign In Required',
  message = 'You need to be signed in to play songs and access your library.',
}) => {
  const { authModalRequired, clearAuthModal } = usePlayer();
  const navigate = useNavigate();

  if (!authModalRequired) return null;

  const handleSignIn = () => {
    clearAuthModal();
    navigate('/login');
  };

  const handleClose = () => {
    clearAuthModal();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-xl p-6 max-w-md w-full border border-gray-800 shadow-xl">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-naia-pink/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-naia-pink" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <h3 className="text-xl font-bold text-white">{title}</h3>
          <p className="text-gray-400 mt-2">{message}</p>
        </div>
        
        <div className="flex flex-col gap-3">
          <button
            onClick={handleSignIn}
            className="w-full py-3 bg-naia-pink hover:bg-opacity-80 text-white rounded-xl transition-colors font-medium"
          >
            Sign In
          </button>
          <button
            onClick={handleClose}
            className="w-full py-3 bg-gray-800 hover:bg-gray-700 text-white rounded-xl transition-colors font-medium"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthRequiredModal;
